import React, { useEffect, useRef, useState } from "react";
import {
  Accordion,
  AccordionItem,
  Link,
  Switcher,
  Notification,
  LoadingSpinner,
  Icon
} from "pepsico-ds";
import "./home.css";
import { useTranslation } from "react-i18next";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Welcome from "./welcome";
import { useUserProfile } from "../../common/user_profile_context";
import { Tooltip } from "react-tooltip";
import PowerBIReport from '../workflow/power_bi_reports';
import { useDispatch, useSelector } from "react-redux";
import { ActionTypes } from "../../Redux/Constants/ActionTypes";

const HomeView = ({ roles }) => {
  const { REACT_APP_API_ENDPOINT, REACT_APP_APIGEE } = process.env;
  const { userProfile, loading } = useUserProfile();
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const [gpid, setgpid] = useState("");
  const [userName, setUserName] = useState("");
  const [selectedApp, setSelectedApp] = React.useState(null);
  const [isChangePasswordBanner, setIsChangePasswordBanner] = useState(false);
  const [systemsUnderMaintenance,setSystemsUnderMaintenance] = useState(false);
  const [isPamSvcAccountRequestsBanner,setIsPamSvcAccountRequestsBanner] = useState(false);
  const [expDaysIn, setExpDaysIn] = useState();
  const [selectedTabIndex, setSelectedTabIndex] = useState(0);
  const [selectedRightTabIndex, setSelectedRightTabIndex] = useState(0);
  const [selectedPendingApprovalTabIndex, setSelectedPendingApprovalTabIndex] =
    useState(0);

  const [formattedDate, setFormattedDate] = useState(0);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [isTab, setIsTab] = useState(
    window.innerWidth > 768 && window.innerWidth <= 1024
  );
  const [selectedView, setSelectedView] = useState("halfCard");
  const recommendedAppsRef = useRef(null);
  const [headingTruncatedTooltip, setHeadingTruncatedTooltip] = useState({});
  const [descTruncatedTooltip, setDescTruncatedTooltip] = useState({});
  const [recommendedApps, setRecommendedApps]= useState(userProfile?.appRecommendation?.recommendedApps?.length > 0 ? userProfile?.appRecommendation?.recommendedApps : []);
  const sapApps = [
    "global sap applications",
    "international sap access",
    "pepsico global template sap applications",
    "sap na non production",
    "sap na production",
    "pgt sap non-production access",
    "international sap access",
    "sap ibp",
  ]

  useEffect(()=>{
    setRecommendedApps(userProfile?.appRecommendation?.recommendedApps);
  },[userProfile?.appRecommendation?.recommendedApps])

  useEffect(()=>{
      if (recommendedAppsRef.current) {
          const headingElements = recommendedAppsRef.current.querySelectorAll(".recommended-card .app-heading");
          const descElements = recommendedAppsRef.current.querySelectorAll(".recommended-card .app-desc");
          const truncatedHeadingTooltipObj = {};
          const truncatedDescTooltipObj = {};

          headingElements.forEach((el, idx) => {
              const isTruncated =
              el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

              truncatedHeadingTooltipObj[idx] = isTruncated;
          });

          descElements.forEach((el, idx) => {
              const isTruncated =
              el.scrollWidth > el.clientWidth || el.scrollHeight > el.clientHeight;

              truncatedDescTooltipObj[idx] = isTruncated;
          });

          setHeadingTruncatedTooltip(truncatedHeadingTooltipObj);
          setDescTruncatedTooltip(truncatedDescTooltipObj);
      }
      
  },[recommendedApps]);

  const userToken = JSON.parse(localStorage.getItem("okta-token-storage"))
    ?.idToken?.idToken;
  const accessToken = JSON.parse(localStorage.getItem("okta-token-storage"))
    ?.accessToken?.accessToken;
  let userGpId = "";
  const [rowData] = useState([
    {
      requestNumber: "01159421",
      requestType: "ISUM Exception Queue 1",
      requester: "John Doe",
      requestedDate: "10/10/2021",
      dueDate: "10/10/2021",
    },
    {
      requestNumber: "01159422",
      requestType: "ISUM Exception Queue 2",
      requester: "Doe",
      requestedDate: "10/10/2021",
      dueDate: "10/10/2021",
    },
    {
      requestNumber: "01159423",
      requestType: "ISUM Exception Queue 3",
      requester: "John Doe 1",
      requestedDate: "10/10/2021",
      dueDate: "10/10/2021",
    },
    {
      requestNumber: "01159424",
      requestType: "ISUM Exception Queue 4",
      requester: "Doe John",
      requestedDate: "10/10/2021",
      dueDate: "10/10/2021",
    },
    {
      requestNumber: "01159425",
      requestType: "ISUM Exception Queue 5",
      requester: "John Doe",
      requestedDate: "10/10/2021",
      dueDate: "10/10/2021",
    },
    {
      requestNumber: "01159426",
      requestType: "ISUM Exception Queue 6",
      requester: "John Doe",
      requestedDate: "10/10/2021",
      dueDate: "10/10/2021",
    },
  ]);

  const [columnDefs] = useState([
    {
      headerName: "Request #",
      field: "requestNumber",
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Request Type",
      field: "requestType",
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Requester",
      field: "requester",
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Requested Date",
      field: "requestedDate",
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Due Date",
      field: "dueDate",
      filter: false,
      floatingFilter: false,
    },
    {
      headerName: "Actions",
      field: "actions",
      filter: false,
      floatingFilter: false,
    },
  ]);

  const [currentAccessdata, setCurrentAccessdata] = useState({
    currentAccess: {
      myidM: [
        "TEAMVIEWER FRONTLINE APPLICATION",
        "LinkedIn Enterprise",
        "Sales Technologies Go To Market (GTM)",
      ],
    },
    responseStatus: "Success",
    responseMessage: "USER CURRENT ACCESS FETCHED SUCCESSFULLY",
    messageCode: 100,
  });
  const [approvalData, setApprovalData] = useState({});
  const [myidMApprovalCount, setMyidMApprovalCount] = useState(0);
  const [isManager, setIsManager] = useState(false);
  const [countStatus, setCountStatus] = useState(false);
  const [pepAGMApprovalCount, setPepAGMApprovalCount] = useState(0);
  const [entraCount, setEntraCount] = useState(0);
  const [retirementCount, setRetirementCount] = useState(0);
  const [myPamCount, setMyPamCount] = useState(0);
  const [ssoCount, setSsoCount] = useState(0);
  const [recentActivityData, setRecentActivityData] = useState({
    recentViews: [
      {
        id: "1",
        label: "Pending app...• Req # 01159421 ...",
        link: "#",
      },
      {
        id: "2",
        label: "Manage other...User: Amit Gupta",
        link: "#",
      },
      {
        id: "3",
        label: "Manage other...User: Us...",
        link: "#",
      },
      {
        id: "4",
        label: "Task list:Update OTP Mobile Nu...",
        link: "#",
      },
      {
        id: "5",
        label: "Task list:Update OTP Mobile Nu...",
        link: "#",
      },
      {
        id: "1",
        label: "Pending app...• Req # 01159421 ...",
        link: "#",
      },
      {
        id: "2",
        label: "Manage other...User: Amit Gupta",
        link: "#",
      },
      {
        id: "3",
        label: "Manage other...User: Us...",
        link: "#",
      },
      {
        id: "4",
        label: "Task list:Update OTP Mobile Nu...",
        link: "#",
      },
      {
        id: "5",
        label: "Task list:Update OTP Mobile Nu...",
        link: "#",
      },
    ],
    responseStatus: "Success",
    responseMessage: "FALI TO FETCHED RECENT VIEW DETAILS",
    messageCode: 100,
  });

  const data = JSON.parse(localStorage.getItem("okta-token-storage"));
  const changePassword = () => {
    navigate("/change-password");
  };
  const openPAMSVCLink = () =>{
    navigate("/pam-svc-account");
  }
  const createForm = () => {
    navigate("/form/form-builder");
  };
  if (!userName && data?.accessToken?.claims?.displayname) {
    setUserName(data?.accessToken?.claims?.displayname);
  }
  const navigateToQuickLinks = (path) => {
    if (path === "/approvals") {
      sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
      sessionStorage.setItem("entraCount", entraCount);
      sessionStorage.setItem("retirementCount", retirementCount);
      sessionStorage.setItem("myPamCount", myPamCount);
      sessionStorage.setItem("ssoCount", ssoCount);
      // if (roles?.includes("isApprovals")) {
      navigate(path, { state: { roles, myidMApprovalCount, entraCount, retirementCount, myPamCount, ssoCount } });
      // }
    }
    else {
      navigate(path);
    }
  };

  const onAppSelect = (app) => {
    setSelectedApp(app);
  };

  // const renderSlides = () => {
  //   const slides = [];
  //   slides.push(
  //     <div className="flex" key="quicklinks-1">
  //       <div
  //         className="quickLinks cursor-pointer"
  //         onClick={() => navigateToQuickLinks("/approvals")}
  //       >
  //         <div className="approval_logo_background"></div>
  //         <div className="quickLinksLabel">
  //           <span>{t("viewRequest")}</span>
  //         </div>
  //       </div>
  //       <div className="quickLinks cursor-pointer" onClick={createForm}>
  //         <div className="password_logo_background"></div>
  //         <div className="quickLinksLabel">
  //           <span>{t("createForm")}</span>
  //         </div>
  //       </div>
  //       <div className="quickLinks cursor-pointer" onClick={changePassword}>
  //         <div className="password_logo_background"></div>
  //         <div className="quickLinksLabel">
  //           <span>{t("changePassword")}</span>
  //         </div>
  //       </div>
  //       <div className="quickLinks cursor-pointer">
  //         <div className="profile_logo_background"></div>
  //         <div className="quickLinksLabel">
  //           <span>{t("profileUpdate")}</span>
  //         </div>
  //       </div>
  //     </div>
  //   );

  //   if (selectedApp === "myidM") {
  //     slides.push(
  //       <div className="flex" key="quicklinks-2">
  //         <div className="quickLinks cursor-pointer">
  //           <div className="message_logo_background"></div>
  //           <div className="quickLinksLabel">
  //             <strong>{t("messageBoard")}</strong>
  //           </div>
  //         </div>
  //       </div>
  //     );
  //   }

  //   return slides;
  // };

  React.useEffect(() => { }, []);

  // const fetchUserProfile = () => {
  //   var data;
  //   let expInDays;
  //   axios
  //     .get(REACT_APP_API_ENDPOINT + "getUserProfile")
  //     .then((response) => {
  //       if (response?.data) {
  //         setApprovalData(response?.data);
  //         data = response.data;
  //         expInDays = data?.pwdExpInDays;
  //         setExpDaysIn(data?.pwdExpInDays);
  //         setIsChangePasswordBanner(expInDays < 15 ? true : false);
  //         if (expInDays > 0) {
  //           let today = new Date();
  //           const futureDate = new Date(today);
  //           futureDate.setDate(today.getDate() + expInDays);
  //           const options = { month: "short", day: "2-digit" };
  //           setFormattedDate(
  //             t("passwordUpdateRequired") +
  //               futureDate.toLocaleDateString("en-US", options)
  //           );
  //         } else {
  //           setFormattedDate("Password Expired");
  //         }
  //         setIsManager(data?.isManager);
  //       }
  //     })
  //     .catch((error) => {
  //       console.warn(
  //         "***** Error thrown for the Access detail api ***** ",
  //         error?.response?.data?.message
  //       );
  //       data = {
  //         "pwdExpInDays": 20,
  //         "preferredLanguage": "en-US",
  //         "gpid": "73120677",
  //         "displayedFirstName": "EndUserConversion",
  //         "displayedLastName": "PTTestuser",
  //         "email": null,
  //         "status": "Success",
  //         "message": "User Details Fetched Successfully",
  //         "isManager": false
  //       }
  //       expInDays = data?.pwdExpInDays;
  //       setExpDaysIn(data?.pwdExpInDays);
  //       setIsChangePasswordBanner(expInDays < 15 ? true : false);

  //       if (expInDays > 0) {
  //         let today = new Date();
  //         const futureDate = new Date(today);
  //         futureDate.setDate(today.getDate() + expInDays);
  //         const options = { month: "short", day: "2-digit" };
  //         setFormattedDate(
  //           t("passwordUpdateRequired") +
  //             futureDate.toLocaleDateString("en-US", options)
  //         );
  //       } else {
  //         setFormattedDate("Password Expired");
  //       }
  //       setIsManager(data?.isManager);
  //       setApprovalData(data);
  //     });
  // }

  const fetchEntraCount = () => {
    axios
      .post(REACT_APP_API_ENDPOINT + "entra/pendingRequests/count")
      .then((response) => {
        if (response?.data && response?.data?.status === "Success") {
          setEntraCount(response?.data?.requestCount)
        }else{
          setEntraCount(0)
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        setEntraCount(0)
      })
    
  }

  const fetchretirementCount = () => {
    axios
      .get(REACT_APP_API_ENDPOINT + "application-retirement/approvals/pending/count")
      .then((response) => {
        if (response?.data?.count) {
          setRetirementCount(response?.data?.count)
        }else{
          setRetirementCount(0)
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        setRetirementCount(0)
      })
    
  }
  // const fetchRecommendedApps = () => {
  //   axios
  //     .get(REACT_APP_API_ENDPOINT + "recommendedApps")
  //     .then((response) => {
  //       if (response?.data && response?.data?.totalCount> 0) {
  //         setRecommendedApps(response?.data?.recommendedApps)
  //       }else{
  //         setRecommendedApps([])
  //       }
  //     })
  //     .catch((error) => {
  //       console.warn(
  //         "***** Error thrown for the Access detail api ***** ",
  //         error?.response?.data?.message
  //       );
  //       setRecommendedApps([])
  //     })
  // }
  const fetchMyPamCount = () => {
    axios
      .get(REACT_APP_API_ENDPOINT + "pam/safeManagement/pendingApprovals/count")
      .then((response) => {
        if (response?.data && response?.data?.success) {
          setMyPamCount(response?.data?.pendingCount)
        }else{
          setMyPamCount(0)
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        setMyPamCount(0)
      })
    
  }

  const fetchSsoCount = () => {
    axios
      .get(REACT_APP_API_ENDPOINT + "sso/approvals/pending/count")
      .then((response) => {
        if (response?.data && response?.data?.count !== undefined) {
          setSsoCount(response?.data?.count)
        }else{
          setSsoCount(0)
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the SSO approvals count api ***** ",
          error?.response?.data?.message
        );
        setSsoCount(0)
      })
  }

  const fetchRequestCount = () => {
    setCountStatus(false);
    var data;
    axios
      .post(REACT_APP_API_ENDPOINT + "user/requestCount")
      .then((response) => {
        if (response?.data && response?.data?.responseStatus === "Success") {
          data = response.data;
          setMyidMApprovalCount(data?.myidmCount);
          setPepAGMApprovalCount(data?.pepAGMCount);
          setCountStatus(true);
        }
        else{
          data = {
            pendingRequests: {
              myidmCount: 0,
              pepAGMCount: 0,
            },
          };
          setMyidMApprovalCount(data?.pendingRequests?.myidmCount);
          setPepAGMApprovalCount(data?.pendingRequests?.pepAGMCount);
          setCountStatus(true);
        }
      })
      .catch((error) => {
        console.warn(
          "***** Error thrown for the Access detail api ***** ",
          error?.response?.data?.message
        );
        data = {
          pendingRequests: {
            myidmCount: 0,
            pepAGMCount: 0,
          },
        };

        setMyidMApprovalCount(data?.pendingRequests?.myidmCount);
        setPepAGMApprovalCount(data?.pendingRequests?.pepAGMCount);
        setCountStatus(true);
      });
  };

  useEffect(() => {
    if (loading || !userProfile) return;
    let expInDays;
    setApprovalData(userProfile);
    expInDays = userProfile?.pwdExpInDays;
    setExpDaysIn(userProfile?.pwdExpInDays);
    setIsPamSvcAccountRequestsBanner(userProfile?.isServiceAccountPresent)
    setSystemsUnderMaintenance(userProfile?.systemsUnderMaintenance);    
    setIsChangePasswordBanner(expInDays < 15 ? true : false);
    if (expInDays > 0) {
      let today = new Date();
      const futureDate = new Date(today);
      futureDate.setDate(today.getDate() + expInDays -1);
      const options = { month: "short", day: "2-digit" };
      setFormattedDate(
        t("passwordUpdateRequired") + " " +
        futureDate.toLocaleDateString("en-US", options)
      );
    } else {
      setFormattedDate("Password Expired");
    }
    setIsManager(userProfile?.isManager);
  }, [userProfile, loading, i18n.language]);

  useEffect(() => {
    fetchRequestCount();
    fetchEntraCount();
    fetchretirementCount();
    fetchMyPamCount();
    fetchSsoCount();
    // fetchRecommendedApps();
    // fetchUserProfile();
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
      setIsTab(window.innerWidth > 768 && window.innerWidth <= 1024);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  // const slides = React.useMemo(() => renderSlides(), [selectedApp]);

  const Tree = ({ data }) => {
    const renderTree = (obj) => {
      return (
        <div>
          {Object.keys(obj).map((branch) => (
            <div>
              <div>
                <div>
                  <div>
                    <div className="accessHead">{branch}</div>
                    <div className="label-container">
                      {obj[branch].slice(0, 2).map((subBranch, index) => (
                        <div key={index} className="label">
                          {subBranch}
                        </div>
                      ))}
                      {obj[branch].length > 2 && (
                        <div className="label">+{obj[branch].length - 2}</div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      );
    };

    return (
      <div className="tree">{renderTree(currentAccessdata.currentAccess)}</div>
    );
  };

  if (!gpid && data?.accessToken?.claims?.gpid) {
    userGpId = data?.accessToken?.claims?.gpid;
  }
  if (!userName && data?.accessToken?.claims?.displayname) {
    setUserName(data?.accessToken?.claims?.displayname);
  }
  React.useEffect(() => { }, [selectedApp]);

  const getSelectedCardView = (selectedCard) => {
    setSelectedView(selectedCard);
  };

  let pwdExpDays = 90;
  React.useEffect(() => {
    if (userGpId === "") {
      userGpId = "51945194";
    }
  }, []);

  const selectedTab = (index) => {
    setSelectedTabIndex(index);
  };
  const selectedRightTab = (index) => {
    setSelectedRightTabIndex(index);
  };
  const selectedPendingApprovalTab = (index) => {
    setSelectedPendingApprovalTabIndex(index);
  };

  return (
    <div id="landingPage" className={isMobile ? "landingAlignments" : ""} >
      <div id="welcomepage"
        className="col-12 pl-0 pr-0"
        style={{ display: "grid", gap: "12px" }}
      >
        <h5 className={i18n.language?.split('-')?.[0] === 'ar' ? 'mr-3' : 'ml-3'} >
          {t("hello")}{" "}
          {userName.length > 30 ? `${userName.substring(0, 30)}...` : userName}!{" "}
        </h5>
        
        {Array.isArray(systemsUnderMaintenance) && systemsUnderMaintenance.length > 0 && (
          <div className="changePwdBanner">
            {systemsUnderMaintenance?.map((notification, index) => (
              <Notification
                key={`${notification}-${index}`}
                className="mb-1"
                secondaryActionLabel="Check Status"
                secondaryActionOnClick={() => {
                  window.location.reload();
                }}
                showActionButtons
                showIcon
                showText
                showTitle
                style={{}}
                text={`${notification} services are currently unavailable. Our team is working to restore functionality.`}
                title={`${notification} Outage`}
                type="warning"
              />
            ))}
          </div>
        )}

        {isChangePasswordBanner && (
          <div className="changePwdBanner">
            <Notification
              primaryActionLabel={t("homePage.change_password_button")}
              primaryActionOnClick={changePassword}
              secondaryActionLabel={t("homePage.close_button")}
              secondaryActionOnClick={() => setIsChangePasswordBanner(false)}
              text={
                expDaysIn > 0
                  ? t("passwordExpirationNotice")
                  : "Your password has expired. Please update it promptly to ensure uninterrupted access to our services."
              }
              title={formattedDate}
              type="info"
            />
          </div>
        )}
        {/* {isPamSvcAccountRequestsBanner && (
          <div className="changePwdBanner">
            <Notification
              primaryActionLabel={t("homePage.svc_account_button")}
              primaryActionOnClick={openPAMSVCLink}
              secondaryActionLabel={t("homePage.close_button")}
              secondaryActionOnClick={() => setIsPamSvcAccountRequestsBanner(false)}
              text={t("homePage.pam_svc_banner_text")}
              title={t("homePage.pam_svc_heading")}
              type="info"
            />
          </div>
        )} */}
        {
          (userProfile?.pepappiamcentralfeatures?.includes('AppsSuggestion') && recommendedApps?.length>0) ? 
          <div className="recommended-apps-container" ref={recommendedAppsRef}>
            <div className="recommended-apps-heading">
              {t("homePage.recommended_apps_tailored_to_your_role")}
            </div>
            <div className="recommended-cards-container">
              {
                recommendedApps.map((recApp, index)=>(
                  <div className="recommended-card" key={recApp?.appName + recApp?.appDescription}
                    onClick={() =>{
                        if(sapApps.map((app)=>app?.toLowerCase?.()).includes(recApp?.appName?.toLowerCase?.())){
                          window.open(
                            "https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestSAPAccess%7D&task.clear=1",
                            "_blank"
                          )
                        }
                        else{
                          window.open(
                            "https://myidm.ite.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
                            "_blank"
                          )
                        }
                    }}
                  >
                    <div className="app-heading"
                      {...(headingTruncatedTooltip[index] && {"data-tooltip-id": recApp?.appName, "data-tooltip-content": recApp?.appName})}
                      style={{...(headingTruncatedTooltip[index] && {cursor: "pointer"})}}
                    >{recApp?.appName}</div>
                    <Tooltip id={recApp?.appName} place="bottom" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                    <div className="app-desc"
                    dangerouslySetInnerHTML={{ __html: recApp?.appDescription }}
                      {...(descTruncatedTooltip[index] && {"data-tooltip-id": recApp?.appDescription, "data-tooltip-content": recApp?.appDescription})}
                      style={{...(descTruncatedTooltip[index] && {cursor: "pointer"})}}
                    ></div>
                    <Tooltip render={() => <div dangerouslySetInnerHTML={{ __html: recApp?.appDescription }} />} id={recApp?.appDescription} place="bottom" style={{ maxWidth: '200px' }} type="light" effect="solid" />
                  </div>
                ))
              }
            </div>
          </div>
          :
          null
        }
        <div
          className={isMobile ? "d-grid" : "d-flex"}
          style={{ gap: isMobile ? "12px" : "0px" }}
        >
          <div
            className={
              isMobile
                ? "col-12 announcement-card"
                : selectedView === "fullCard"
                  ? `col-12 announcement-card ${i18n.language?.split('-')?.[0] === 'ar' ? 'pl-0' : 'pr-0'}`
                  : !/\/home(\/|$)/.test(window.location.pathname) &&
                    selectedView === "halfCard"
                    ? "col-9"
                    : `col-12 announcement-card ${i18n.language?.split('-')?.[0] === 'ar' ? 'pl-0' : 'pr-0'}`
            }
          >
            <Welcome
              onSelect={onAppSelect}
              setSelectCard={getSelectedCardView}
              myidMApprovalCount={myidMApprovalCount}
              isManager={isManager}
              roles={roles}
            />
          </div>
          {!/\/home(\/|$)/.test(window.location.pathname) &&
            selectedView === "halfCard" && (
              <div
                className={isMobile ? "col-12" : "col-3 pl-0 pr-0"}
                id="activity"
              >
                <div className="card " style={{ height: "280px" }}>
                  <div className="card-content">
                    <div>
                      <Switcher
                        items={[{
                          label: "Recently viewed"
                        },
                        {
                          label: "User activity"
                        }]}
                        onUpdate={(val) => selectedRightTab(val)}
                        selectedItemIndex={selectedRightTabIndex}
                      />
                    </div>
                    {selectedRightTabIndex === 0 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      ></div>
                    )}
                    {selectedRightTabIndex === 1 && (
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          width: "100%",
                        }}
                      ></div>
                    )}
                  </div>
                </div>
              </div>
            )}
        </div>

        <div
          className={isMobile || isTab ? "d-grid" : "d-flex"}
          style={{ gap: isMobile || isTab ? "0px" : "0px" }}
        >
          <div
            className={
              isMobile || isTab
                ? "col-12 access-request-card adjustPadding"
                : `col-12 access-request-card ${i18n.language?.split('-')?.[0] === 'ar' ? 'pl-0' : 'pr-0'}`
            }
          >
            <div
              className={isMobile || isTab ? "d-grid" : "d-flex"}
              style={{ gap: "12px" }}
              id="accessRequests"
            >
              <div
                className={`card  ${isTab ? "subCard" : "maincard"}`}
                style={{
                  padding: "12px",
                  width: isTab ? "calc((100% - 25%) / 2) !important" : "33%",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span className="sectionHeader">
                    {t("homePage.approvals")} / {t("homePage.actions")}
                  </span>
                </div>
                <div style={{ padding: "8px 0px",  display: "flex" }}>
                  <Switcher
                    items={[{
                      label: t("homePage.pending")
                    },
                    {
                      label: t("homePage.overdue")
                    }
                    ]}
                    onUpdate={(val) => selectedPendingApprovalTab(val)}
                    selectedItemIndex={selectedPendingApprovalTabIndex}
                  />
                  <Icon
                      alt="alt value"
                      className="$color-icon-default p-1 mr-1"
                      icon="refresh"
                      data-tooltip-id="refresh-tooltip" data-tooltip-content="Refresh"
                      size="small"
                      onClick={() => {fetchRequestCount();fetchEntraCount();fetchretirementCount();fetchMyPamCount();fetchSsoCount();}}
                      style={{ alignItems: 'center', marginLeft: '0.5rem', cursor: 'pointer' }}
                  />
                </div>
                {selectedPendingApprovalTabIndex === 0 && (
                  <div className="card approvalCard" style={{ margin: 0 }}>
                    <div
                      className="card-content w-full"
                      style={{ padding: "6px", display: "grid" }}
                    >
                      {!countStatus && (
                        <div
                          style={{ display: "flex", justifyContent: "center" }}
                        >
                          <LoadingSpinner
                            size={{
                              height: "50px",
                              width: "50px",
                            }}
                          />
                        </div>
                      )}
                      {countStatus && (
                        <div>
                          <h3
                            className="bold-text text-left pl-md-3"
                            // style={{ paddingLeft: "20px" }}
                          >
                            { (userProfile?.pepappiamcentralfeatures?.includes('SafeManagement') ? Number(myPamCount) : 0) + (userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') ? Number(entraCount) : 0) + Number(retirementCount) + (userProfile?.pepappiamcentralfeatures?.includes('SSOOnboardingApprovals') ? Number(ssoCount) : 0) + Number(myidMApprovalCount) +
                              (pepAGMApprovalCount == "10+"
                                ? 10
                                : Number(pepAGMApprovalCount))}
                            {pepAGMApprovalCount == "10+" ? "+" : ""}{" "}
                          </h3>
                          <div>
                            <div
                            className="px-md-3"
                              style={{
                                textAlign: "left",
                                display: "grid",
                                // padding: "0px 20px",
                              }}
                            >
                              {/* <h3 className="bold-text">{myidMApprovalCount + pepAGMApprovalCount}</h3> */}
                              {(userProfile?.pepappiamcentralfeatures?.includes('SafeManagement') ? Number(myPamCount) : 0) + (userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') ? Number(entraCount) : 0) + Number(retirementCount) + (userProfile?.pepappiamcentralfeatures?.includes('SSOOnboardingApprovals') ? Number(ssoCount) : 0) + Number(myidMApprovalCount) +
                                (pepAGMApprovalCount === "10+"
                                  ? 10
                                  : Number(pepAGMApprovalCount)) ===
                                0 && (
                                  <span
                                    style={{ textAlign: "left" }}
                                    className="accordion-item-label"
                                  >
                                    {t("homePage.pending_desc")}
                                  </span>
                                )}
                              {myidMApprovalCount > 0 && (
                                <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                  <span className="accordion-item-label">
                                    myidM - {myidMApprovalCount}
                                  </span>
                                  <span>
                                    <Link
                                      onClick={() => {
                                        userProfile?.pepappiamcentralfeatures?.includes('Approvals') ? 
                                        navigateToQuickLinks("/approvals"):
                                      window.open("https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals","_blank")
                                      }}
                                      // target="_blank"
                                      label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                      // showIconTrailing
                                      style={{
                                        paddingLeft: "2.75rem",
                                        paddingRight: "0.75rem",
                                      }}
                                      useAnchor
                                      size="small"
                                    />
                                  </span>
                                </span>
                              )}
                              {(pepAGMApprovalCount > 0 ||
                                pepAGMApprovalCount == "10+") && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label" style={{ width: '90px' }}>
                                      pepAGM - {pepAGMApprovalCount}
                                    </span>
                                    <span>
                                      <Link
                                        href="https://pepagm.mypepsico.com/sigma/app/index#/campaigns"
                                        target="_blank"
                                        label={`${t("approvals.maintain")}/${t("approvals.revoke")}`}
                                        // showIconTrailing
                                        style={{
                                          paddingLeft: "2rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                                {entraCount > 0  && userProfile?.pepappiamcentralfeatures?.includes('GuestInvitation') && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label" style={{ width: '90px' }}>
                                      {t("entraGuest.entra")} - {entraCount}
                                    </span>
                                    <span>
                                      <Link
                                        onClick={() => {
                                          sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                          sessionStorage.setItem("entraCount", entraCount);
                                          sessionStorage.setItem("retirementCount", retirementCount);
                                          sessionStorage.setItem("myPamCount", myPamCount);
                                          sessionStorage.setItem("ssoCount", ssoCount);
                                          navigate("/approvals", { state: { isEntraApproval:true, myidMApprovalCount, entraCount, retirementCount, myPamCount, ssoCount } });
                                        }}
                                        label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                        style={{
                                          paddingLeft: "2.75rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                                {retirementCount > 0  && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label">
                                      {t("app_retirement.application_retirements")} - {retirementCount}
                                    </span>
                                    <span>
                                      <Link
                                        onClick={() => {
                                          sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                          sessionStorage.setItem("entraCount", entraCount);
                                          sessionStorage.setItem("retirementCount", retirementCount);
                                          sessionStorage.setItem("myPamCount", myPamCount);
                                          sessionStorage.setItem("ssoCount", ssoCount);
                                          navigate("/approvals", { state: { isRetirementApproval:true, myidMApprovalCount, entraCount, retirementCount, myPamCount, ssoCount } });
                                        }}
                                        label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                        style={{
                                          paddingLeft: "2.75rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                                {myPamCount > 0 && userProfile?.pepappiamcentralfeatures?.includes('SafeManagement')  && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label" style={{ width: '90px' }}>
                                      {t("homePage.mypam")} - {myPamCount}
                                    </span>
                                    <span>
                                      <Link
                                        onClick={() => {
                                          sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                          sessionStorage.setItem("entraCount", entraCount);
                                          sessionStorage.setItem("retirementCount", retirementCount);
                                          sessionStorage.setItem("myPamCount", myPamCount);
                                          sessionStorage.setItem("ssoCount", ssoCount);
                                          navigate("/approvals", { state: { isMyPamApproval:true, myidMApprovalCount, entraCount, retirementCount, myPamCount, ssoCount } });
                                        }}
                                        label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                        style={{
                                          paddingLeft: "2.75rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                                {ssoCount > 0 && userProfile?.pepappiamcentralfeatures?.includes('SSOOnboardingApprovals') && (
                                  <span style={{ display: "flex", justifyContent: "space-between", alignItems: "baseline" }}>
                                    <span className="accordion-item-label" style={{ width: '90px' }}>
                                      SSO - {ssoCount}
                                    </span>
                                    <span>
                                      <Link
                                        onClick={() => {
                                          sessionStorage.setItem("myidMApprovalCount", myidMApprovalCount);
                                          sessionStorage.setItem("entraCount", entraCount);
                                          sessionStorage.setItem("retirementCount", retirementCount);
                                          sessionStorage.setItem("myPamCount", myPamCount);
                                          sessionStorage.setItem("ssoCount", ssoCount);
                                          navigate("/approvals", { state: { isSSOApproval:true, myidMApprovalCount, entraCount, retirementCount, myPamCount, ssoCount } });
                                        }}
                                        label={`${t("approvals.approve")}/${t("approvals.reject")}`}
                                        style={{
                                          paddingLeft: "2.75rem",
                                          paddingRight: "0.75rem",
                                        }}
                                        useAnchor
                                        size="small"
                                      />
                                    </span>
                                  </span>
                                )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                )}
                {(selectedPendingApprovalTabIndex === 3 ||
                  selectedPendingApprovalTabIndex === 1) && (
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        width: "100%",
                        height: "-webkit-fill-available",
                      }}
                    >
                      <span> {t("homePage.coming_soon")}</span>
                    </div>
                  )}
                {selectedPendingApprovalTabIndex === 2 && (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      alignItems: "center",
                      width: "100%",
                    }}
                  >
                    {/* <img
                      src={work_inprogress}
                      style={{ minWidth: "150px", width: "150px" }}
                      alt="work in progress"
                    /> */}
                  </div>
                )}
              </div>
              <div
                className={`card access-request-card ${isTab ? "subCard" : "maincard"
                  }`}
                style={{
                  padding: "12px",
                  width: isTab ? "calc((100% - 25%) / 2) !important" : "33%",
                }}
              >
                <div
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <span className="sectionHeader">
                    {t("homePage.accessRequest")}
                  </span>
                </div>
                <Accordion
                  className="pending-request-accordion"
                  alignment="right"
                  onUpdate={function Qa() { }}
                  size="medium"
                  state="enable"
                >
                  <AccordionItem
                    alignment="right"
                    label={t("homePage.pending_request")}
                  >
                    <div className="innerTitleName"></div>
                    <div className="innerTitleInfo mt-0">
                      <div
                        className="link"
                        onClick={() => {
                          if(userProfile?.pepappiamcentralfeatures?.includes('RequestAudit')){
                            navigate("/audit-requests",{state: {statusFilter:"in progress"}})
                          }
                          else{
                            window.open(
                            "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=ViewMyRequestsAuditSAP",
                            "_blank"
                          );
                          }
                          
                        }}
                        style={{ fontSize: "10px" }}
                      >
                        {" "}
                        {t("homePage.get_details")}
                      </div>
                    </div>
                  </AccordionItem>
                  <AccordionItem
                    alignment="right"
                    label={t("homePage.current_access")}
                  >
                    <div className="innerTitleName"></div>
                    <div className="innerTitleInfo mt-0">
                      <div
                        className="link"
                        onClick={() => {
                          if(userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')){
                          navigate("/request-access")
                          }
                          else{
                            window.open(
                            "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
                            "_blank"
                          );
                          } 
                        }}
                        style={{ fontSize: "10px" }}
                      >
                        {" "}
                        {t("homePage.view_details")}
                      </div>
                    </div>
                  </AccordionItem>

                  <AccordionItem
                    alignment="right"
                    label={t("homePage.new_requests")}
                    className="new-requests"
                  >
                    <div className="innerTitleName"></div>
                    <div
                      className="innerTitleInfo mt-0"
                      style={{ display: "contents" }}
                    >
                      <div className="d-flex justify-content-between">
                        <div style={{fontSize:"14px"}}>
                          {t("homePage.general_application_request")}
                        </div>
                        <div className="d-flex">
                          <div
                            className="link mr-2"
                            onClick={() => {
                              if(userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')){
                                navigate("/request-new-access");
                              }
                              else{
                              window.open(
                                "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestNewAccessForSelf",
                                "_blank"
                              );
                              }
                            }}
                            style={{ fontSize: "10px" }}
                          >
                            Self
                          </div>
                          <div
                            className="link"
                            onClick={() => {
                              if(userProfile?.pepappiamcentralfeatures?.includes('RequestAccess')){
                              navigate('/myidm', { state: { navigateFrom: 'request_access_others' } });
                              }
                              else{
                              window.open(
                                "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PepsiCoRequestAccessForOtherAssociate",
                                "_blank"
                              );
                              }
                            }}
                            style={{ fontSize: "10px" }}
                          >
                            Others
                          </div>
                          </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div style={{fontSize:"14px"}}>
                          {t("homePage.sap_access_request")}
                        </div>
                        <div
                        className="link"
                        onClick={() => {
                          window.open(
                            "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.RequestSAPAccess%7D&task.clear=1",
                            "_blank"
                          );
                        }}
                        style={{ fontSize: "10px" }}
                      >
                        <Icon
                          alt="alt value"
                          icon="arrow_forward"
                          size="medium"
                          style={{ marginLeft: '4px' }}
                        />
                      </div>
                      </div>
                      <div className="d-flex justify-content-between">
                        <div style={{fontSize:"14px"}}>
                          {t("homePage.technology_application_request")}
                        </div>
                        <div
                          className="link"
                          onClick={() => {
                            window.open(
                              "https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?console.tab=%24%7Bbundle%3DresourceBundles.PepsiCo_environment_roles_Tokenized%3Akey%3Dcategory.TechnologyRequest.name%7D&task.clear=1",
                              "_blank"
                            );
                          }}
                          style={{ fontSize: "10px" }}
                        >
                          <Icon
                            alt="alt value"
                            icon="arrow_forward"
                            size="medium"
                            style={{ marginLeft: '4px' }}
                          />
                        </div>
                      </div>
                    </div>
                  </AccordionItem>
                </Accordion>
              </div>
              <div
                className={
                  isMobile || isTab
                    ? "col-12 announcement-card pl-0 pr-0 card card-layout maincard"
                    : "announcement-card pl-0 pr-0 card card-layout maincard"
                }
              >
                <div id="announcements">
                  <div
                    style={{ display: "flex", justifyContent: "space-between" }}
                  >
                    <span className="sectionHeader">
                      {" "}
                      {t("homePage.announcements")}{" "}
                    </span>
                  </div>
                  <Accordion
                    alignment="right"
                    onUpdate={function Qa() { }}
                    size="medium"
                    state="enable"
                  >
                    <AccordionItem
                      alignment="right"
                      label={t("homePage.iam_services")}
                      subTitle={t("homePage.iam_services_desc")}
                    >
                      {/* <div className="innerTitleInfo">
                        <div className="link" style={{ fontSize: "10px" }}>
                          {" "}
                          {t("homePage.get_started")}
                        </div>
                      </div> */}
                    </AccordionItem>

                    {isManager && (
                      <AccordionItem
                        alignment="right"
                        label="Dashboard and Metric report"
                        subTitle="view progress"
                        badge={{
                          isCopyable: false,
                          text: "New",
                        }}
                      >
                        <div className="innerTitleInfo">
                          <div
                            className="link"
                            onClick={() => {
                              window.open(
                                "https://app.powerbi.com/groups/me/reports/e7082366-5654-41d6-920f-6c6490a507c0/ReportSection?experience=power-bi ",
                                "_blank"
                              );
                            }}
                            style={{ fontSize: "10px" }}
                          >
                            {" "}
                            Get details
                          </div>
                        </div>
                      </AccordionItem>
                    )}
                  </Accordion>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default HomeView;
